import React from 'react';
import { ensureStyleElement, loadExternalScript, removeExternalScript, removeStyleElement } from 'shared/utils/dom/scripts';

const JIVO_SCRIPT_ID = 'jivo-widget-script';
const JIVO_SCRIPT_SRC = '//code.jivo.ru/widget/zPD7vyG2A5';
const HIDE_STYLE_ID = 'hide-jivo-style';

export default function JivoChatLoader() {
  React.useEffect(() => {
    // On mount within UDMainLayout: ensure widget is visible and load script
    removeStyleElement(HIDE_STYLE_ID);
    loadExternalScript(JIVO_SCRIPT_SRC, JIVO_SCRIPT_ID).catch(() => {
      // ignore load errors silently
    });

    // On unmount (leaving UDMainLayout): hide widget and remove script
    return () => {
      ensureStyleElement(
        HIDE_STYLE_ID,
        '[id^="jivo"], [class*="jivo"], .jivo-widgets, #jivo-iframe-container, #jivo_container { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }',
      );
      removeExternalScript(JIVO_SCRIPT_ID);
    };
  }, []);

  return null;
}
